<script setup lang="ts">
import { formatCurrency } from "shared/helpers";
import { capitalize } from "vue";

import { getImageUrl } from "~/common/helpers/get-image-url";
import { sizeNormalize } from "~/common/helpers/size-adapter";

const cartStore = useCartStore();
</script>

<template>
	<ul class="flex flex-col">
		<li v-for="(cartItem, i) in cartStore.getCartItemsAdapted" :key="`${cartItem.product.id}:${i}`" class="py-4 flex">
			<NuxtImg
				v-if="cartItem.product.imageIds.length"
				:src="getImageUrl(cartItem.product.imageIds[0], { width: 256, height: 340 })"
				:width="128"
				:height="170"
				alt="image"
			/>
			<div class="flex flex-col justify-between w-full pl-4">
				<div class="flex justify-between items-center text-lg">
					<span>{{ cartItem.product.name }}</span>
					<AppButtonIcon
						class="text-green-dark"
						name="ic:round-close"
						size="16"
						@click="cartStore.deleteProductFromCart(i)"
					/>
				</div>
				<div class="text-sm text-green-dark">
					<div v-if="cartItem.text" class="mb-[2px]">
						{{ capitalize($t('customText')) }}: <span class="text-black">{{ cartItem.text }}</span>
					</div>
					<div>
						{{ capitalize($t('size')) }}: <span class="text-black">{{ sizeNormalize(cartItem.size).name }}</span>
					</div>
					<div class="flex items-center">
						{{ capitalize($t('material')) }}:
						<CartMaterial :material="cartItem.material" />
					</div>
				</div>
				<div class="flex w-full justify-between items-center">
					<CommonAmount
						:model-value="cartItem.amount"
						class="flex items-center justify-between text-gray-dark text-sm w-10 xs:w-8"
						:min="1"
						:max="100"
						@update:model-value="(value) => cartStore.changeItemAmount(i, value)"
					/>
					<div class="font-medium text-xl xs:text-lg">
						{{ formatCurrency(cartItem.total) }}
					</div>
				</div>
			</div>
		</li>
	</ul>
</template>

<style scoped>
::-webkit-scrollbar-thumb {
	background: #e7e7ec;
}

::-webkit-scrollbar-thumb:hover {
	background: #222222;
}
</style>
